import { useConnectionState, useZero as useZ, useQuery as useZQ } from "@rocicorp/zero/react";
import type { Schema } from "../types";

function useZero() {
	const api = useZ<Schema>();
	return api;
}

function useZeroOnline() {
	const connectionState = useConnectionState();
	return connectionState.name === "connected";
}

export { useConnectionState, useZero, useZeroOnline, useZQ as useZeroQuery };
